import { BioexameResolver } from "./bioexame.resolver";

export const MarcacaoResolver = [
  BioexameResolver
]
